import { QueryClient } from '@tanstack/react-query';
import { employeeQueries } from '@/queries/employee';
import { homeLocationQueries } from '@/queries/homelocation/homelocation.query';
import { airportsQuery } from '@/queries/airports';
import { hubQueries } from '@/queries/hub';
import { AffiliationType } from '@/api/apis/resources';
import { txCenterQueries } from '@/queries/tx-centers';
import { opoQueries } from '@/queries/opo';

export const employeeByIdLoader = (queryClient: QueryClient) => async (employeeId: string) => {
  const employee = await queryClient.ensureQueryData({
    ...employeeQueries.item(employeeId),
    revalidateIfStale: true,
  });
  let homeLocation;
  let airport;
  let baseLocation;
  let txCenter;
  let opo;
  if (employee.homeLocation) {
    homeLocation = await queryClient.ensureQueryData({
      ...homeLocationQueries.item(employee.homeLocation),
    });
  }
  if (employee.closestAirportForDeployment) {
    airport = await queryClient.ensureQueryData({
      ...airportsQuery.item(String(employee.closestAirportForDeployment), 'maoIds'),
    });
  }
  if (employee.baseLocation) {
    baseLocation = await queryClient.ensureQueryData({
      ...hubQueries.item(employee.baseLocation),
    });
  }
  if (employee.affiliation?.affiliationType === AffiliationType.TXCenter) {
    txCenter = await queryClient
      .ensureQueryData({
        ...txCenterQueries.item(employee.affiliation.txCenterId),
      })
      .catch(() => undefined); // Workaround TMDXLP-9462; Should be handled on BE side
  }
  if (employee.affiliation?.affiliationType === AffiliationType.OPO) {
    opo = await queryClient.ensureQueryData({
      ...opoQueries.item(employee.affiliation.opoId),
    });
  }
  return { employee, homeLocation, airport, baseLocation, txCenter, opo };
};
